import { createContext, useContext } from 'react';

/**
 * Shared state for the Dialog compound parts — provided by `DialogSurface` so
 * `DialogTitle` / `DialogClose` / `DialogFooter` etc. work both inside the
 * prop-driven skeleton and in fully composed children.
 */
export interface DialogContextValue {
  align: 'left' | 'center';
  /** Dismiss handler — `DialogClose` presses this. */
  onClose?: () => void;
  /** The dialog's root `testID`; parts derive `<testID>-<part>` from it. */
  testID?: string;
}

export const DialogContext = createContext<DialogContextValue>({ align: 'left' });

export function useDialogContext(): DialogContextValue {
  return useContext(DialogContext);
}
